function ConfermaInvioEmailVerifica() {


	return (
		<div className="d-flex align-items-center justify-content-center">
			<p>Email di verifica inviata con successo. Controlla la tua posta elettronica e conferma l'indirizzo email.</p>
		</div >
	);
}

export default ConfermaInvioEmailVerifica;